"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconKeys = exports.Icons = void 0;
const codepoints_json_1 = __importDefault(require("../../assets/custom-icons/codepoints.json"));
exports.Icons = codepoints_json_1.default;
exports.IconKeys = Object.keys(exports.Icons).sort((a, b) => a > b ? 1 : -1);
// Set icon name from list of codepoints
const iconNames = [...exports.IconKeys];
//# sourceMappingURL=Icon.types.js.map